import {
  GET_MANUAL_FLIGHT_REQUEST,
  GET_MANUAL_FLIGHT_SUCCESS,
  GET_MANUAL_FLIGHT_FAILURE,
  GET_ALL_IATA_CODES_REQUEST,
  GET_ALL_IATA_CODES_SUCCESS,
  GET_ALL_IATA_CODES_FAILURE,
  ADD_MANUAL_FLIGHT_REQUEST,
  ADD_MANUAL_FLIGHT_SUCCESS,
  ADD_MANUAL_FLIGHT_FAILURE,
  EDIT_MANUAL_FLIGHT_REQUEST,
  EDIT_MANUAL_FLIGHT_SUCCESS,
  EDIT_MANUAL_FLIGHT_FAILURE,
  DELETE_FLIGHT_REQUEST,
  DELETE_FLIGHT_SUCCESS,
  DELETE_FLIGHT_FAILURE,
  CLEAR_IATA, GET_IATA_CODES_REQUEST,
  GET_IATA_CODES_SUCCESS,
  GET_IATA_CODES_FAILURE,
  CLEAR_MANUAL_FLIGHT,
} from './types/FlightInformationActionTypes';

export function getAllIataCodesRequestActionCreator(action) {
  return {
    type: GET_ALL_IATA_CODES_REQUEST,
    payload: action,
  };
}

export function getAllIataCodesSuccessActionCreator(data) {
  return {
    type: GET_ALL_IATA_CODES_SUCCESS,
    payload: data,
  };
}

export function getAllIataCodesFailureActionCreator(error) {
  return {
    type: GET_ALL_IATA_CODES_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteFlightRequestActionCreator(payload) {
  return {
    type: DELETE_FLIGHT_REQUEST,
    payload,
  };
}

export function deleteFlightSuccessActionCreator(data) {
  return {
    type: DELETE_FLIGHT_SUCCESS,
    payload: data,
  };
}

export function deleteFlightFailureActionCreator(error) {
  return {
    type: DELETE_FLIGHT_FAILURE,
    payload: error,
    error: true,
  };
}

export function postAddManualFlightRequestActionCreator(payload) {
  return {
    type: ADD_MANUAL_FLIGHT_REQUEST,
    payload,
  };
}

export function postAddManualFlightSuccessActionCreator(data) {
  return {
    type: ADD_MANUAL_FLIGHT_SUCCESS,
    payload: data,
  };
}

export function postAddManualFlightFailureActionCreator(error) {
  return {
    type: ADD_MANUAL_FLIGHT_FAILURE,
    payload: error,
    error: true,
  };
}

export function putEditManualFlightRequestActionCreator(payload) {
  return {
    type: EDIT_MANUAL_FLIGHT_REQUEST,
    payload,
  };
}

export function putEditManualFlightSuccessActionCreator(data) {
  return {
    type: EDIT_MANUAL_FLIGHT_SUCCESS,
    payload: data,
  };
}

export function putEditManualFlightFailureActionCreator(error) {
  return {
    type: EDIT_MANUAL_FLIGHT_FAILURE,
    payload: error,
    error: true,
  };
}

export function clearPreservedIATA() {
  return {
    type: CLEAR_IATA,
  };
}

export function getIataCodesRequestActionCreator(action) {
  return {
    type: GET_IATA_CODES_REQUEST,
    payload: action,
  };
}

export function getIataCodesSuccessActionCreator(data) {
  return {
    type: GET_IATA_CODES_SUCCESS,
    payload: data,
  };
}

export function getIataCodesFailureActionCreator(error) {
  return {
    type: GET_IATA_CODES_FAILURE,
    payload: error,
    error: true,
  };
}

export function getManualFlightRequestActionCreator(action) {
  return {
    type: GET_MANUAL_FLIGHT_REQUEST,
    payload: action,
  };
}

export function getManualFlightSuccessActionCreator(data) {
  return {
    type: GET_MANUAL_FLIGHT_SUCCESS,
    payload: data,
  };
}

export function getManualFlightFailureActionCreator(error) {
  return {
    type: GET_MANUAL_FLIGHT_FAILURE,
    payload: error,
    error: true,
  };
}
export function clearManualFlightDataActionCreator() {
  return {
    type: CLEAR_MANUAL_FLIGHT,
    payload: null,
  };
}
